<section>
  <!-- Header -->
  <header class="mx-4" [class.is-stuck]="isStuck">
    <nav
      class="navbar navbar-expand-lg navbar-dark py-1 py-lg-3 px-1 px-md-4"
      role="navigation"
      aria-label="Primary"
      [ngClass]="{
        'header-gradient': !isOurFleet,
        'nav-white-bg': isOurFleet,
        'fleet-theme': isOurFleet,
      }"
    >
      <div class="container-fluid position-relative">
        <!-- Hamburger for mobile/tablet - left aligned -->
        <button
          class="navbar-toggler d-lg-none position-absolute top-50 start-0 translate-middle-y"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar"
          aria-controls="offcanvasNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Logo -->
        <a
          class="navbar-brand mx-auto mx-lg-3 ps-4 ps-md-0"
          href="/"
          routerLink="/"
          aria-label="Homepage"
        >
          <img
            [src]="isOurFleet ? '/images/logo-black.svg' : '/images/logo.svg'"
            alt="Q-Mobility Rent A Car logo"
            width="220"
            height="32"
          />
        </a>

        <!-- Full menu for large screen -->
        <div
          class="collapse navbar-collapse justify-content-lg-end d-lg-flex d-none"
          id="navbarNav"
        >
          <ul class="navbar-nav m-auto">
            <li class="nav-item">
              <a
                #rlaHome="routerLinkActive"
                class="nav-link"
                href="/"
                routerLink="/"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                [attr.aria-current]="rlaHome.isActive ? 'page' : null"
                >Home</a
              >
            </li>
            <!-- <li class="nav-item">
              <a #rlaChauffeur="routerLinkActive" class="nav-link" href="/chauffeur-service" routerLink="/chauffeur-service" routerLinkActive="active" [attr.aria-current]="rlaChauffeur.isActive ? 'page' : null">Chauffeur Service</a>
            </li> -->
            <li class="nav-item">
              <a
                #rlaLongTerm="routerLinkActive"
                class="nav-link"
                href="/long-term-service"
                routerLink="/long-term-service"
                routerLinkActive="active"
                [attr.aria-current]="rlaLongTerm.isActive ? 'page' : null"
                >Long-Term Service</a
              >
            </li>
            <li class="nav-item">
              <a
                #rlaFleet="routerLinkActive"
                class="nav-link"
                href="/our-fleet"
                routerLink="/our-fleet"
                routerLinkActive="active"
                [attr.aria-current]="rlaFleet.isActive ? 'page' : null"
                >Our Fleet</a
              >
            </li>
            <li class="nav-item">
              <a
                #rlaContact="routerLinkActive"
                class="nav-link"
                href="/contact-us"
                routerLink="/contact-us"
                routerLinkActive="active"
                [attr.aria-current]="rlaContact.isActive ? 'page' : null"
                >Contact Us</a
              >
            </li>
          </ul>

          <!-- Login + Preferences -->
          <div class="d-flex align-items-center justify-content-center flex-wrap">
            <button
              type="button"
              mat-stroked-button
              class="auth-btns btn-signup ff-poppins-semibold me-3"
              (click)="onSignup()"
            >
              Create Account
            </button>
            <button
              type="button"
              mat-stroked-button
              class="auth-btns btn-login ff-poppins-semibold"
              (click)="onLogin()"
            >
              Log in
            </button>
            <app-user-preferences [hasLanguage]="false" [hasThemes]="false"></app-user-preferences>
          </div>
        </div>
      </div>
    </nav>
  </header>

  <!-- Offcanvas for mobile/tablet - opens from left -->
  <div
    class="offcanvas offcanvas-start"
    tabindex="-1"
    id="offcanvasNavbar"
    aria-labelledby="offcanvasNavbarLabel"
  >
    <div class="offcanvas-header position-relative">
      <!-- <h5
        class="offcanvas-title ff-poppins-medium"
        style="margin-bottom: 8rem"
        id="offcanvasNavbarLabel"
      >
        {{ "What would you like to do today?" | translate }}
      </h5> -->
      <mat-icon class="icon-close" data-bs-dismiss="offcanvas" aria-label="Close">clear</mat-icon>
    </div>
    <div class="offcanvas-body">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a
            #rlaHomeSm="routerLinkActive"
            class="nav-link"
            href="/"
            routerLink="/"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            [attr.aria-current]="rlaHomeSm.isActive ? 'page' : null"
            data-bs-dismiss="offcanvas"
            >Home</a
          >
        </li>
        <!-- <li class="nav-item">
                <a #rlaChauffeurSm="routerLinkActive" class="nav-link" href="/chauffeur-service" routerLink="/chauffeur-service" routerLinkActive="active" [attr.aria-current]="rlaChauffeurSm.isActive ? 'page' : null" data-bs-dismiss="offcanvas">Chauffeur Service</a>
              </li> -->
        <li class="nav-item">
          <a
            #rlaLongTermSm="routerLinkActive"
            class="nav-link"
            href="/long-term-service"
            routerLink="/long-term-service"
            routerLinkActive="active"
            [attr.aria-current]="rlaLongTermSm.isActive ? 'page' : null"
            data-bs-dismiss="offcanvas"
            >Long-Term Service</a
          >
        </li>
        <li class="nav-item">
          <a
            #rlaFleetSm="routerLinkActive"
            class="nav-link"
            href="/our-fleet"
            routerLink="/our-fleet"
            routerLinkActive="active"
            [attr.aria-current]="rlaFleetSm.isActive ? 'page' : null"
            data-bs-dismiss="offcanvas"
            >Our Fleet</a
          >
        </li>
        <li class="nav-item">
          <a
            #rlaContactSm="routerLinkActive"
            class="nav-link"
            href="/contact-us"
            routerLink="/contact-us"
            routerLinkActive="active"
            [attr.aria-current]="rlaContactSm.isActive ? 'page' : null"
            data-bs-dismiss="offcanvas"
            >Contact Us</a
          >
        </li>
      </ul>
      <div class="d-flex flex-column align-items-center gap-2 mt-3 px-3">
        <button
          type="button"
          mat-stroked-button
          class="auth-btns w-100 ff-poppins-semibold mb-3"
          (click)="onSignup()"
        >
          Create Account
        </button>
        <button
          type="button"
          mat-stroked-button
          class="auth-btns w-100 ff-poppins-semibold"
          (click)="onLogin()"
        >
          Log in
        </button>
        <app-user-preferences [hasLanguage]="false" [hasThemes]="false"></app-user-preferences>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <main class="flex-grow-1" style="background-color: var(--main-layout-background-color)">
    <router-outlet></router-outlet>
  </main>

  <!-- Footer -->
  <app-footer></app-footer>
</section>
